/**
 @Developper: BenAli Faker
 @Company: SMART-INFO
 @Post: CTO
 @Date:12/02/2021
 @Time:07:43
 **/
import LangueService from "../../../i18n/service/LangueService";

import 'select2/dist/js/select2';
for(const locale of  ['ar','fr','en'])
{
    $.fn.select2.amd.define('select2/i18n/'+locale,[],require("select2/src/js/select2/i18n/"+locale));
}
export default class Select2
{
    /**
     * attacher select2 plugin a un objet query
     * @param {jQuery}jqueryElement
     */
    static attachSelect2(jqueryElement){
    Begro.logInfo("début Configuration de select2");
    let langue=LangueService.getInstance().activeLangue!==null?LangueService.getInstance().activeLangue.langue:'fr';
    if(LangueService.getInstance().activeLangue){
        langue=LangueService.getInstance().activeLangue.langue;
    }
    Begro.logInfo("Langue utilisée avec select 2 est: "+langue)
    jqueryElement.select2({
            containerCssClass:":all:",
            language:langue,
            width: '100%'
    });
    Begro.logInfo("fin Configuration de select2");
    }
}

$(document).ready(
    function(){
       Select2.attachSelect2($(".select2 select"));
    }
);